const footerCols = [
  {
    title: "频道盘点",
    links: ["综艺名场面", "影视路透", "音乐现场", "时尚红毯", "电竞热话", "圈内花边"],
  },
  {
    title: "快速导航",
    links: ["今日速览", "热议榜", "全瓜复盘", "网友开麦", "吃瓜FAQ"],
  },
];

export default function Footer() {
  const go = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const map: Record<string, string> = {
      今日速览: "#daily",
      热议榜: "#hot",
      全瓜复盘: "#recap",
      网友开麦: "#reviews",
      吃瓜FAQ: "#faq",
      综艺名场面: "#channels",
      影视路透: "#channels",
      音乐现场: "#channels",
      时尚红毯: "#channels",
      电竞热话: "#channels",
      圈内花边: "#channels",
    };
    const target = map[href] ?? "#top";
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-background-800 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 pb-8 pt-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-chat-3-fill text-lg"></i>
              </span>
              <span className="serif-title text-xl font-bold text-background-50">
                吃瓜<span className="text-accent-300">今日</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              一份面向泛娱乐网民的晚间瓜田日报。把今天综艺、影视、音乐、红毯、电竞的瓜，规整成一份清楚的收尾盘点。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-700 text-background-200">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-700 text-background-200">
                <i className="ri-douban-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-700 text-background-200">
                <i className="ri-video-chat-line"></i>
              </span>
            </div>
          </div>

          {footerCols.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#top" onClick={(e) => go(e, l)} className="text-sm text-background-300 transition-colors hover:text-accent-200 cursor-pointer">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-background-700 pt-6 sm:flex-row sm:items-center">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-background-300">
            <a href="mailto:hello@chiguajinri.example" className="inline-flex items-center gap-1.5 transition-colors hover:text-accent-200">
              <i className="ri-mail-line"></i> 编辑部邮箱
            </a>
            <span>理性吃瓜 · 不传谣不站队</span>
          </div>
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 吃瓜今日 Chigua Jinri · 内容仅供参考，请理性看待网络信息
          </p>
        </div>
      </div>
    </footer>
  );
}